import React, { useCallback, useState } from "react";
import { Image } from "antd";
import Loader from "../atoms/global/Loader";
import { useDispatch } from "react-redux";
import { getFileActionWithRetry } from "../../../redux/files/actions";

const FileHolder = ({ file }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [updatedSignedUrl, setUpdatedSignedUrl] = useState(file?.url)

  const videoExtensions = ['.mp4', '.avi', '.mkv', '.mov', '.webm'];
  const unSupportedVideoExtensions = ['.wmv'];
  const imgExtensions = ['.png', '.jpg', '.jpeg', '.gif', '.bmp'];
  const docExtensions = ['.doc', '.docx', '.txt', '.rtf'];
  const pptExtensions = ['.ppt', '.pptx'];
  const excelExtensions = ['.xls', '.xlsx'];
  const svgExtension = ['.svg'];

  const isVideo = videoExtensions.some(ext => file?.name?.includes(ext));
  const isImage = imgExtensions.some(ext => file?.label?.includes(ext)) ||  imgExtensions.some(ext => file?.name?.includes(ext));
  const isCsv = file?.name?.includes('.csv');
  const isPdf = file?.name?.includes('.pdf');
  const isDoc = docExtensions.some(ext => file?.name?.includes(ext));
  const isPpt = pptExtensions.some(ext => file?.name?.includes(ext));
  const isExcel = excelExtensions.some(ext => file?.name?.includes(ext));
  const isSvg = svgExtension.some(ext => file?.name?.includes(ext));
  const isUnsupportedVideo = unSupportedVideoExtensions.some(ext => file?.name?.includes(ext));

  const iconMap = {
    pdf: '/images/icons/pdf.svg',
    doc: '/images/icons/document-file.svg',
    video: '/images/icons/video2.svg',
    csv: '/images/icons/excel.svg',
    ppt: '/images/icons/ppt.svg',
    excel: '/images/icons/excel.svg'
  }

  const icon = isVideo || isUnsupportedVideo ? iconMap.video : isCsv ? iconMap.csv : isPdf ? iconMap.pdf : isDoc ? iconMap.doc : isPpt ? iconMap.ppt : isExcel ? iconMap.excel : iconMap.doc;

  const handleError = useCallback(async () => {
      setLoading(true);
      const { signedUrl } = await dispatch(getFileActionWithRetry(file?.fileId));
      // TODO: Take the signedUrl from store. For this files store needs to be updated to save the data from getting tasks
      setUpdatedSignedUrl(signedUrl);
      setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [file?.fileId]);

  if (!file?.url) {
    return;
  }

  return (
    <>      
      {/* <Loader size={25} isLoading={loading} type='clip' /> */}
      {isImage ?
        <Image
          src={updatedSignedUrl}
          // onLoad={handleImageLoad}
          style={{
            objectFit: 'cover',
            objectPosition: 'center',
            maxHeight: '250px',
            maxWidth: '360px',
          }}
          onError={handleError}
        /> :
      isVideo ?
        <video controls width="300" height="150">
          <source src={updatedSignedUrl} type="video/mp4" onError={handleError} />
          Your browser does not support the video tag.
        </video> :
        <a
          href={file.url}
          download={file.name}
          style={{
            textDecoration: 'none',
            display: 'flex',
            alignItems: 'center',
            color: 'blue', // You can style the link text color
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: '5px',
              border: '1px solid #ccc',
              borderRadius: '5px',
              marginRight: '10px',
            }}
          >
            <img
              src={icon}
              alt="PDF Icon"
              style={{
                width: '20px',
                height: '20px',
                marginRight: '5px',
              }}
            />
            {file.name}
          </div>
        </a>}    </>

  );
};

export default FileHolder;
